import { Tabs } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ProgressBarStep, ProgressBarStepItem } from '../../../../../global/components/progress-bar-step';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { genericStepperStyles } from '../../../../../global/constants/theme/styles/components/generic-stepper';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { AccountInfoRoutes } from '../../../../account-info/constants/routes';
import { Completed, InProgress, NotStarted } from '../../../constants/constant-strings';
import { ArcRoutes } from '../../../constants/routes';
import { NewHireProps } from '../../../models/arc-epi-props';
import { NewHireStep } from '../../new-hire/models/new-hire-model';
import { setCurrentNewHireEmployeeReviewStep } from '../slice/new-hire-enrollment-slices';


const steps = [NewHireStep.PersonalInfo, NewHireStep.PersonReviewInternal];

interface ProgressProps {
	basePath: string;
}

function EmployeeReviewProgressBar(props: ProgressProps) {

	const { basePath } = props;
	const currentStep = useSelector<TcsmStates, NewHireStep>(state => state?.newHireEnrollmentState?.currentEmployeeReviewStep);
	const buttonClasses = buttonStyles();

	const classes = genericStepperStyles();
	const stepIndex = steps.indexOf(currentStep);
	const history = useHistory();
	const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const dispatch = useDispatch();
	const getProgress = (idx: number, current: number) => {
		if (idx === current) return InProgress;

		return idx > current ? NotStarted : Completed;
	};
	const getStepId = (idx: number, current: number) => {
		if (idx === current) return ProgressBarStep.INPROGRESS;
		return idx > current ? ProgressBarStep.NOTSTARTED : ProgressBarStep.COMPLETED;
	};

	const onStepperClick = (step: NewHireStep, subPath: string) => {
		history.push(`${basePath}${subPath}`);
		dispatch(setCurrentNewHireEmployeeReviewStep(step));
	};

	const showLink = (idx: number, current: number) => {
		return idx < current;
	};


	const getStepNameNode = (name: string, link: string, step: NewHireStep) => {

		if (link) {
			return (
				<button
					className={buttonClasses.linkButton}
					type='button'
					onClick={() =>
						onStepperClick(step, link)} >
					{name}
				</button>
			);
		}

		return (
			<p>{name}</p>
		);
	};

	return (
		<div className={classes.genericStepperContainer}>
			<Tabs
				variant="scrollable"
				scrollButtons
				className='generic-stepper-bar'
			>
				<ProgressBarStepItem
					stepNameNode={
						getStepNameNode(
							settings?.personInfoStepName,
							showLink(0, stepIndex) && AccountInfoRoutes.PersonalInfoSegment,
							NewHireStep.PersonalInfo,
						)
					}
					progress={getProgress(0, stepIndex)}
					stepId={getStepId(0, stepIndex)}
				/>
				<ProgressBarStepItem
					stepNameNode={
						getStepNameNode(
							settings?.employmentCompensationStepName,
							showLink(1, stepIndex) && ArcRoutes.Employment,
							NewHireStep.PersonReviewInternal,
						)
					}
					progress={getProgress(1, stepIndex)}
					stepId={getStepId(1, stepIndex)}
				/>
			</Tabs>
		</div>
	);
}

export default EmployeeReviewProgressBar;